import React, { Component } from 'react';
import { numbersWithComma } from '../utils/utils';
import { Modal } from 'react-bootstrap';
import DamagedBanner from './DamagedBanner';
import DamagedModal from './DamagedModal';

const airIcon = 'https://cdn.shippingcart.com/assets/001-plane-20230321064808.svg';
const seaIcon = 'https://cdn.shippingcart.com/assets/037-cargo-ship-20230321064815.svg';
const itemListIcon = 'https://cdn.shippingcart.com/assets/item-list-graphic-20231115084133.svg';
const protectedIcon = 'https://cdn.shippingcart.com/assets/protect-20231116072249.svg'
const unProtectedIcon = 'https://cdn.shippingcart.com/assets/no_protect-20231116072255.svg'
const scProtectBadge = 'https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg'


const INSURANCE_BENEFITS = [
  {
    protected: 'Up to 100% refund on your insured value.',
    notProtected: 'No protection against loss or damage during transit.',
  },
  {
    protected: 'Up to 100% refund on shipping when delivered late',
    notProtected: 'No refund for shipping fee in case of delay.',
  },
  {
    protected:
      'Up to P5,000 coverage on merchant return.',
    notProtected:
      'No shipping fee refunds when returning wrong or defective items to the merchant.',
  },
];

class CheckoutBreakdown extends Component {
  state = { 
    itemModal: '',
    isSCProtectDetailsShown: true,
    scProtectModal: false,
    damagedModalOpen: false,
  }

  close = () => {
    this.setState({ itemModal: '' });
  }

  alertBanner = () => {
    if (this.props.data && !this.props.data.insurance_eligible && this.props.data.insurance_error && this.props.data.insurance_error.total_package_value) {
      return (
        <DamagedBanner
          message="Your shipment is not eligible for SC Protect coverage as the total value exceeds the maximum limit of USD 20,000.00."
          bgColor="#FFE9EB"
          damaged={false}
        />
      )
    } else {
      if (this.props.data && this.props.data.damage_items && !!this.props.data.damage_items.total) {
        return (
          <DamagedBanner
            message={
              <div>
                <span style={{ fontWeight: 600 }}>
                  {this.props.data.damage_items.total} out of{' '}
                  {this.props.data.summary.usd.total_qty} packages
                </span>{' '}
                contains{' '}
                <span
                  style={{ color: '#0375D9', fontWeight: 600, cursor: 'pointer' }}
                  onClick={() => this.setState({ damagedModalOpen: true })}
                >
                  damaged item
                </span>{' '}
                which are excluded from SC Protect when you checkout.
              </div>
            }
            bgColor="#FFE9EB"
          />
        )
      }
      return '';
    }
  }

  handleFixedAirCargo = () => {
    if (this.props.data.air.usd && this.props.data.air.usd.single_parcel_fixed_rate) {
      return (
        <div style={{ display: "inline-flex", alignItems: "center" }}>
          Fixed Air Cargo Fee
        </div>
      );
    }
    return (
      <div style={{display: 'inline-flex', alignItems: 'center'}}>
        Total Air Cargo Fee 
        <div className="fa fa-question-circle" style={{width: '18px', height: '18px', marginLeft: '5px'}}>
          <div className="checkout tooltip white" style={{backgroundColor: '#316edc', width: '250px', left: '-111px'}}>
          <div style={{borderBottom : '1px solid #F1F1F1', paddingBottom: '10px'}}>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <span style={{fontSize: '13px'}}>Chargeable weight</span>
              <span>{this.props.data.air.usd.total_chargeable_weight} lbs</span>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <span style={{fontSize: '13px', textTransform: 'capitalize'}}>Air Cargo rate</span>
              <span><span style={{ marginRight: '5px' }}>X</span> {`USD ${numbersWithComma(Number(this.props.data.air.usd.per_pound_value).toFixed(2)) || 0.00}`}</span>
            </div>
          </div>
          <div style={{borderBottom : '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '10px'}}>
            <div style={{display: 'flex', justifyContent: 'right', fontSize: '13px'}}>
            {`USD ${numbersWithComma(this.props.data.air.usd.total_chargeable_amount.toFixed(2)) || 0.00}`}
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <span style={{fontSize: '13px'}}>Fixed handling fee</span>
              <span><span style={{ marginRight: '5px' }}>+</span> 
              {`USD ${numbersWithComma(this.props.data.air.usd.total_fixed_rate && this.props.data.air.usd.total_fixed_rate.toFixed(2)) || 0.00}`}
            </span>
            </div>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>
            <span style={{fontSize: '13px', fontWeight: 600, textTransform: 'capitalize'}}>Total Air Cargo Fee</span>
            <span style={{fontSize: '13px', fontWeight: 600}}>
              {`USD ${numbersWithComma(this.props.data.air.usd.total_cargo) || 0.00}`}
            </span>
          </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const minChargableWeight = this.props.minChargableWeight && JSON.parse(this.props.minChargableWeight.settings);
    return (
      <div>
        {this.props.data && this.props.data.items.hasOwnProperty("air") && 
          <div style={{padding: '20px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', marginBottom: '10px', borderRadius: '4px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 600, color: '#323232', marginBottom: '10px'}}>
            {this.handleFixedAirCargo()}
            <span>{`USD ${numbersWithComma(this.props.data.air.usd.total_cargo)}`}</span>
          </div>
            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px'}}>
              <span style={{fontSize: '16px', fontWeight: 600, color: '#636363'}}>
                <img src={itemListIcon} alt='air' width={18} style={{marginRight: '5px'}}/>
                List of items
              </span>
              <span style={{fontSize: '16px', fontWeight: 600, color: '#0375D9', cursor: 'pointer'}} onClick={() => this.setState({itemModal: 'air'})}>
                {this.props.data.air.total_qty} item/s
              </span>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <span style={{fontSize: '16px', fontWeight: 600, color: '#636363'}}>
                <img src={airIcon} alt='air' width={18} style={{marginRight: '5px'}}/>
                Est. delivery
              </span>
              <span style={{fontSize: '16px', color: '#323232'}}>{this.props.data.delivery.air}</span>
            </div>
          </div>
        }
        {this.props.data && this.props.data.items.hasOwnProperty("sea") && 
          <div style={{padding: '20px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', marginBottom: '10px', borderRadius: '4px'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 600, color: '#323232', marginBottom: '10px'}}>
            <div style={{display: 'inline-flex', alignItems: 'center'}}>
                Total Sea Cargo Fee 
                <div className="fa fa-question-circle" style={{width: '18px', height: '18px', marginLeft: '5px'}}>
                  <div className="checkout tooltip white" style={{backgroundColor: '#316edc', width: '250px', left: '-111px'}}>
                  <div style={{borderBottom : '1px solid #F1F1F1', paddingBottom: '10px'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                      <span style={{fontSize: '13px'}}>Chargeable weight</span>
                      <span>{this.props.data.sea.total_chargeable_weight} lbs</span>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                      <span style={{fontSize: '13px', textTransform: 'capitalize'}}>Sea Cargo rate</span>
                      <span><span style={{ marginRight: '5px' }}>X</span> {`USD ${numbersWithComma(Number(this.props.data.sea.usd.per_pound_value).toFixed(2)) || 0.00}`}</span>
                    </div>
                    {this.props.data.sea && 
                      this.props.data.sea.usd.is_sea_higher_rate && <div style={{fontSize: '10px', fontStyle: 'italic', textAlign: 'left'}}>Higher rates apply if any side of a package is over {minChargableWeight && minChargableWeight.sea_max_dimension && minChargableWeight.sea_max_dimension.value} inches.</div>}
                  </div>
                  <div style={{borderBottom : '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '10px'}}>
                    <div style={{display: 'flex', justifyContent: 'right', fontSize: '13px'}}>
                    {`USD ${numbersWithComma(this.props.data.sea.usd.total_chargeable_amount.toFixed(2)) || 0.00}`}
                    </div>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                      <span style={{fontSize: '13px'}}>Fixed handling fee</span>
                      <span><span style={{ marginRight: '5px' }}>+</span> 
                      {`USD ${numbersWithComma(this.props.data.sea.usd.total_fixed_rate && this.props.data.sea.usd.total_fixed_rate.toFixed(2)) || 0.00}`}
                    </span>
                    </div>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>
                    <span style={{fontSize: '13px', fontWeight: 600, textTransform: 'capitalize'}}>Total Sea Cargo Fee</span>
                    <span style={{fontSize: '13px', fontWeight: 600}}>
                      {`USD ${numbersWithComma(this.props.data.sea.usd.total_cargo) || 0.00}`}
                    </span>
                  </div>
                  </div>
                </div>
              </div>
              <span>{`USD ${numbersWithComma(this.props.data.sea.usd.total_cargo)}`}</span>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px'}}>
              <span style={{fontSize: '16px', fontWeight: 600, color: '#636363'}}>
                <img src={itemListIcon} alt='air' width={18} style={{marginRight: '5px'}}/>
                List of items
              </span>
              <span style={{fontSize: '16px', fontWeight: 600, color: '#0375D9', cursor: 'pointer'}} onClick={() => this.setState({itemModal: 'sea'})}>
                {this.props.data.sea.total_qty} item/s
              </span>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <span style={{fontSize: '16px', fontWeight: 600, color: '#636363'}}>
                <img src={seaIcon} alt='air' width={18} style={{marginRight: '5px'}}/>
                Est. delivery
              </span>
              <span style={{fontSize: '16px', color: '#323232'}}>{this.props.data.delivery.sea}</span>
            </div>
          </div>
        }
        <div style={{padding: '20px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', marginBottom: '10px', borderRadius: '4px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 600, color: '#323232'}}>
            <span>Storage Fee</span>
            <span>{`USD ${this.props.data && numbersWithComma(this.props.data.summary.usd.total_storage_charge.toFixed(2))}`}</span>
          </div>
        </div>
        <div style={{padding: '20px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', marginBottom: '10px', borderRadius: '4px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 600, color: '#323232'}}>
            <span>
              Total SC Protect Fee
              <img src={scProtectBadge} alt='air' width={18} style={{marginLeft: '5px'}}/>
            </span>
            <span>{`USD ${this.props.data && numbersWithComma(this.props.data.summary.usd.total_insurance)}`}</span>
          </div>
         {this.alertBanner()}
          <div style={{ textAlign: 'right' }}>
            <div
              onClick={() => {
                this.setState({isSCProtectDetailsShown: !this.state.isSCProtectDetailsShown})
              }}
            >
              {this.state.isSCProtectDetailsShown ? (
                <i className='fa fa-angle-down' style={{ color: '#636363', fontSize: '20px' }} />
              ) : (
                <i className='fa fa-angle-up' style={{ color: '#636363', fontSize: '20px' }} />
              )}
            </div>
          </div>

          {this.state.isSCProtectDetailsShown && 
            (<div>
              {this.props.isSCProtectActive && this.props.data && this.props.data.insurance_eligible === 1 && <div style={{paddingTop: '20px'}}>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span style={{fontSize: '16px', fontWeight: 600, color: '#636363'}}>
                    Premium
                  </span>
                  <span style={{fontSize: '16px', color: '#323232'}}>USD {this.props.data && this.props.data.insurance && this.props.data.insurance.basic_premium}</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span style={{fontSize: '16px', fontWeight: 600, color: '#636363'}}>
                    Documentary Stamps
                  </span>
                  <span style={{fontSize: '16px', color: '#323232'}}>USD {this.props.data && this.props.data.insurance && this.props.data.insurance.stamps}</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span style={{fontSize: '16px', fontWeight: 600, color: '#636363'}}>
                    Value Added Tax
                  </span>
                  <span style={{fontSize: '16px', color: '#323232'}}>USD {this.props.data && this.props.data.insurance && this.props.data.insurance.vat}</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  <span style={{fontSize: '16px', fontWeight: 600, color: '#636363'}}>
                    Local Government Tax
                  </span>
                  <span style={{fontSize: '16px', color: '#323232'}}>USD {this.props.data && this.props.data.insurance && this.props.data.insurance.lgt}</span>
                </div>
                <hr/>
              </div>}
              {this.props.isSCProtectActive && <div style={{fontSize: '16px', color: '#636363', fontWeight: 600, padding: '10px 0px'}}>
                Summary of Benefits:
              </div>}
              {INSURANCE_BENEFITS.map((benefit, index) => (
                <div style={{ marginBottom: '8px', display: 'flex' }} key={index}>
                  <div style={{marginRight: '5px'}}>
                    <img
                      src={this.props.isSCProtectActive ? protectedIcon : unProtectedIcon}
                      alt="icon"
                    />
                  </div>
                  {this.props.isSCProtectActive ? benefit.protected : benefit.notProtected}
                </div>
              ))}
              <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 600}}>
                Avail SC Protect
                <label className="switch">
                  <input
                    checked={this.props.isSCProtectActive ? 'checked' : ''}
                    type="checkbox"
                    disabled={this.props.data && !this.props.data.insurance_eligible && this.props.data.insurance_error && this.props.data.insurance_error.total_package_value }
                    onChange={()=> !this.props.isSCProtectActive ? this.props.handleSwitchToggle() : this.setState({scProtectModal: true})}
                    />
                  <div className="slider round"></div>
              </label>
              </div>
              {this.props.data && this.props.data.insurance_eligible === 1 && (<div style={{display: 'flex', justifyContent: 'space-between',marginTop: '10px', alignItems: 'center'}}>
                <img src={scProtectBadge} alt='badge' width={18} height={18} style={{ marginRight: '5px' }}/>
                <span style={{fontSize: '10px', fontWeight: 600, color: '#636363'}}>SC Protect, powered by Stere & underwritten by PLGIC, is a partnership between SC and SPI.</span>
              </div>)}
            </div>)
          }
        </div>


        <Modal className="alert-modal-checkout" show={this.state.itemModal} onHide={this.close} autoFocus={true}>
          <Modal.Header closeButton>
            <Modal.Title>Air Cargo Items</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.itemModal && this.props.data.items[this.state.itemModal].map(item => <div key={item.id}>{item.description}</div>)}
          </Modal.Body>
          <Modal.Footer style={{"textAlign": "center"}}>
              <button className="alert-modal-btn btn" onClick={this.close}>OK GOT IT!</button>
          </Modal.Footer>
        </Modal>

        <Modal className="alert-modal-checkout" show={this.state.scProtectModal} onHide={() => this.setState({scProtectModal: false})} autoFocus={true}>
          <Modal.Header closeButton>
            <Modal.Title>Insurance Coverage</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{margin: '5px 0px'}}>Are you sure you don’t want to protect your goods with shipping protection?</div>
            <div style={{margin: '5px 0px'}}>Without SC Protect, your items may be at risk for any unexpected issues; damage or loss during shipping.</div>
            <div style={{margin: '5px 0px'}}>We encourage you to take a moment to reconsider!</div>
          </Modal.Body>
          <Modal.Footer style={{"textAlign": "center"}}>
              <button className="alert-modal-btn btn" style={{width: '100%'}} onClick={() => this.setState({scProtectModal: false})}>AVAIL SC PROTECT</button>
              <a  style={{ color: '#707070', fontWeight: 600, fontSize: 14, display: 'flex', justifyContent: 'center', padding: '15px', alignItems: 'center'  }}  
                onClick={() => {
                  this.props.handleSwitchToggle();
                  this.setState({scProtectModal: false});
                }}>
                Checkout without SC Protect
              </a>
          </Modal.Footer>
        </Modal>

        <DamagedModal
          isOpen={this.state.damagedModalOpen}
          handleClose={() => this.setState({damagedModalOpen : false})}
          damageItems={this.props.data && this.props.data.damage_items}
        />
      </div>
    )
  }
}
export default CheckoutBreakdown;


/** WEBPACK FOOTER **
 ** ./src/components/CheckoutBreakdown.js
 **/